import { SvgIconType } from './types';

export const ChevronLeft = ({
  width = 74,
  height = 95,
}: SvgIconType) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 84 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="-3.18097"
      y="2.80739"
      width="71.2886"
      height="89.5114"
      rx="16"
      transform="matrix(-0.99806 -0.0622631 -0.0622631 0.99806 77.1745 5.4084)"
      fill="white"
      stroke="black"
      strokeWidth="6"
    />
    <path
      d="M47.6799 34.9995L33.1799 49.4996L50.1797 66.4993"
      stroke="black"
      strokeWidth="7"
    />
  </svg>
);

export const ChevronRight = ({
  width = 74,
  height = 95,
}: SvgIconType) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 74 95"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="3.99354"
      y="4.93181"
      width="65.2268"
      height="87.0073"
      rx="16"
      transform="rotate(-1.00453 3.99354 4.93181)"
      fill="white"
      stroke="black"
      strokeWidth="6"
    />
    <path
      d="M31.4998 31.9985L45.9998 46.4985L29 63.4983"
      stroke="black"
      strokeWidth="7"
    />
  </svg>
);
